module.exports = __webpack_public_path__ + "img/n2.1830641a.webp";